<template>
  <div id="pageRoot">
    <div class="tag" style="left: 60px; top: 260px; z-index: 3">
      <p class="textBase tagText">VENANCIO</p>
    </div>

    <div class="tag" style="right: 80px; top: 260px; z-index: 3">
      <p class="textBase tagText">DON FITO</p>
    </div>

    <p id="text01">ERA MUY INTELIGENTE Y OBEDIENTE.</p>
    <p id="text02">ESTABA MUY ORGULLOSO DE SU PERRO.</p>
    <p id="text03">SALTABA CADA VEZ MÁS ALTO.</p>

    <!-- TEXT ----------------------------------------------------------------------------------------------------->
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />
    <!-- TEXT ----------------------------------------------------------------------------------------------------->

    <div id="dog" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage59Dog.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>
    <div id="donFito" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage58DonFito.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <span class="footer-page footer-write"></span>
    <span id="fixedBackground" class="pageElement"></span>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
.tag {
  position: absolute;
  width: 310px;
  height: 70.55px;

  background-image: url(/pages/img/sordo/svgPage75TagMedium.svg);
  background-size: contain;
  background-repeat: no-repeat;
  transform: scale(0.6);
  transition: 0.3s;
}
#fixedBackground {
  position: absolute;
  width: 940px;
  height: 544px;
  left: 47px;
  top: 32px;
  background-image: url(/pages/img/sordo/svgPage58B.svg);
}
#dog {
  position: absolute;
  width: 158.79px;
  height: 150.68px;
  left: 242px;
  top: 210px;
}
#donFito {
  position: absolute;
  width: 135.71px;
  height: 283.63px;
  left: 602px;
  top: 71px;
}
#inputField01 {
  width: 410px;
  margin-left: 55%;
  margin-top: 36.5%;
  position: absolute;
  z-index: 3;
}
#inputField02 {
  width: 365px;
  margin-left: 59.5%;
  margin-top: 45.2%;
  position: absolute;
  z-index: 3;
}
#inputField03 {
  width: 490px;
  margin-left: 47.3%;
  margin-top: 54.1%;
  position: absolute;
  z-index: 3;
}
#txtVenancio {
  /* VENANCIO */
  position: absolute;
  width: 120px;
  height: 70px;
  left: 136px;
  top: 257px;
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 70px;
  /* identical to box height, or 292% */
  text-transform: uppercase;
  color: #ffffff;
}
#txtDonfito {
  /* DON FITO */

  position: absolute;
  width: 112px;
  height: 70px;
  left: 720px;
  top: 260px;
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 70px;
  /* identical to box height, or 292% */
  text-transform: uppercase;
  color: #ffffff;
}
#text01 {
  /* ERA MUY INTELIGENTE Y OBEDIENTE. */

  position: absolute;
  width: 516px;
  height: 60px;
  left: 46px;
  top: 378px;
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 70px;
  /* or 233% */
  text-transform: uppercase;
  color: #000000;
}

#text02 {
  /* ESTABA MUY ORGULLOSO DE SU PERRO. */

  position: absolute;
  width: 564px;
  height: 60px;
  left: 46px;
  top: 468px;
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 70px;
  /* or 233% */
  text-transform: uppercase;
  color: #000000;
}
#text03 {
  /* SALTABA CADA VEZ MÁS ALTO. */

  position: absolute;
  width: 516px;
  height: 60px;
  left: 46px;
  top: 560px;
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 70px;
  /* or 233% */
  text-transform: uppercase;

  color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "p59/V23.mp4",
        "p59/V24.mp4",
        "p59/V25.mp4",
      ],
    };
  },
};
</script>